module.exports = __webpack_public_path__ + "img/system26-details.bf455ce3.png";